module.exports = __webpack_public_path__ + "static/media/logo.ff7841e9.png";